import { render, staticRenderFns } from "./AdminSetupBankMitraTab.vue?vue&type=template&id=00860c9e&"
import script from "./AdminSetupBankMitraTab.vue?vue&type=script&lang=js&"
export * from "./AdminSetupBankMitraTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports